import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { createRemoteVideoMenuButtonEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
import { IconMicSlash } from '../../../base/icons/svg';
import ContextMenuItem from '../../../base/ui/components/web/ContextMenuItem';
import { NOTIFY_CLICK_MODE } from '../../../toolbox/types';
import { sendCommand } from '../../../mod-command/slice';
import { COMMANDS } from '../../../mod-command/constants';
/**
 * Implements a React {@link Component} which displays a button for audio muting
 * a participant in the conference.
 *
 * @returns {JSX.Element|null}
 */
const MuteButton = ({ notifyClick, notifyMode, participantID, noIcon }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const tracks = useSelector((state) => state['features/base/tracks']);
    const handleClick = useCallback(() => {
        notifyClick?.();
        if (notifyMode === NOTIFY_CLICK_MODE.PREVENT_AND_NOTIFY) {
            return;
        }
        sendAnalytics(createRemoteVideoMenuButtonEvent('mute', {
            'participant_id': participantID
        }));
        // dispatch(muteRemote(participantID, MEDIA_TYPE.AUDIO));
        // dispatch(rejectParticipantAudio(participantID));
        dispatch(sendCommand(COMMANDS.MUTE_PARTICIPANT.COMMAND, participantID, true));
    }, [dispatch, notifyClick, notifyMode, participantID, sendAnalytics]);
    return (React.createElement(ContextMenuItem, { accessibilityLabel: t('dialog.muteParticipantButton'), className: 'mutelink', icon: noIcon ? null : IconMicSlash, onClick: handleClick, text: t('dialog.muteParticipantButton') }));
};
export default MuteButton;
